import { render, staticRenderFns } from "./BaseModalFeedback.vue?vue&type=template&id=8e1b9da6"
import script from "./BaseModalFeedback.vue?vue&type=script&lang=js"
export * from "./BaseModalFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports